import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Lock } from "lucide-react";

import { CommercialFooter } from "../components/layout/commercial-footer";

export function CommercialLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");

    try {
      const response = await fetch("/api/login.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();

      if (data.success) {
        // Check role if returned, or let the protected page handle it
        if (data.role === 'commercial' || data.role === 'admin') {
            navigate("/area-commerciale");
        } else {
            setError("Accesso non autorizzato per questo utente.");
        }
      } else {
        setError(data.message || "Credenziali non valide");
      }
    } catch (err) {
      setError("Errore di connessione al server");
      console.error(err);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <div className="flex-grow flex flex-col justify-center items-center px-4">
        <div className="w-full max-w-md bg-white p-8 rounded-xl shadow-lg border border-gray-200">
          <div className="flex flex-col items-center mb-8">
              <img src="/images/logo-puglialife.png" alt="Puglia Life" className="h-16 mb-4" />
              <h1 className="text-2xl font-bold text-[#004080] uppercase tracking-wide text-center">
              Accesso Area Commerciale
              </h1>
          </div>

          {error && (
            <div role="alert" className="bg-red-50 text-red-700 p-4 rounded-lg mb-6 text-sm border border-red-200 flex items-center">
              <Lock className="w-4 h-4 mr-2" />
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label htmlFor="username" className="block text-gray-700 mb-2 font-medium">Username</label>
              <input
                id="username"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#004080] focus:border-transparent transition-all"
                required
                placeholder="Inserisci username"
              />
            </div>
            <div>
              <label htmlFor="password" className="block text-gray-700 mb-2 font-medium">Password</label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#004080] focus:border-transparent transition-all"
                required
                placeholder="Inserisci password"
              />
            </div>
            <Button type="submit" className="w-full h-12 text-lg bg-[#004080] hover:bg-[#003366] text-white font-bold">
              ACCEDI
            </Button>
          </form>
          
          <div className="mt-6 text-center text-sm text-gray-500">
              Area riservata al personale commerciale autorizzato.
          </div>
        </div>
      </div>
      <CommercialFooter />
    </div>
  );
}
